module.exports = __webpack_public_path__ + "img/VG.2ca4e8b8.svg";